import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Output, PLATFORM_ID } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';
import { NetworkPanelComponent } from 'app/modules/network_panel/network_panel.component';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
  standalone: true,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports:[RouterLink, NetworkPanelComponent]
})
export class FooterComponent {

  @Output() focusInput = new EventEmitter<void>();

  constructor(
    private router: Router,
    private _sharedService: SharedServiceService,
    private _authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: any
  ){}

  // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Whatsapp redirection
     */
    public redirectToWhatsApp() {
      
      if (isPlatformBrowser(this.platformId)) {
        window.open('https://api.whatsapp.com/send/?phone=0600687377&text=Please+can+you+assist+me', '_blank');
      }

  }

  focusOnParentInput(): void 
  {
    this.focusInput.emit();
  }

  public onActivate(event) {
    
    if (isPlatformBrowser(this.platformId)) {
      window.scroll({ 
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
 });
    }
 }

 public openSupportProducts() {
  sessionStorage.setItem('catType', 'Products');

  if (sessionStorage.getItem('catType')) {
    this.router.navigate(['/support']);
  }
 }

 public checkUsage() {
  if (this._authService._authenticated) {
      this.router.navigate(['/dashboard']);
    } else {
      this.router.navigate(['/sign-in']);
    }
 }

}
